import { DEBOUNCE_TIMEOUT } from '../constants/toolbar';
let debounceTimeout = null;

/**
 * Returns a debounced `handleInputChange` and non-debounced `handleStepChange`.
 * This hook is targeted for components rendering `UIStepperInput`.
 */
export const useDebouncedOnChange = onChange => {
  const handleInputChange = (...args) => {
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }
    debounceTimeout = setTimeout(() => {
      onChange(...args);
    }, DEBOUNCE_TIMEOUT);
  };
  const handleStepChange = (...args) => {
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }
    onChange(...args);
  };
  return [handleInputChange, handleStepChange];
};